import { useGetQuery } from './useGetQuery';

interface OverviewResponse {
    performance: number;
    currentBalance: number;
    openingBalance: number;
    banks: string[];
}

const useConnectedAccountOverview = () => {
    const { isLoading, entries: overview } = useGetQuery<OverviewResponse>({
        url: 'banks/connect/overview',
        cacheKey: 'connected-overview',
    });

    return { isLoading, overview };
};
export default useConnectedAccountOverview;
